function TrackingAnalytics() {
    'use strict';

    //Constants to check type
    this.types = {
        none: 1,
        google_analytics: 2
    };
}

TrackingAnalytics.prototype = {

    init() {
        this.initAnalytics();
    },

    /**
     * @return {TrackingAnalytics}
     */
    initAnalytics() {
        this.isGADefined = ('gtag' in window);

        if (!this.isGADefined) {
            this.type = this.types.none;
            return this;
        }

        if (this.isGADefined) {
            this.type = this.types.google_analytics;
            return this;
        }
    },






    /**
     * @return {TrackingAnalytics}
     */
    initAvailablity() {
        this.isLoaded = this.isAnalyticsAvailable();
        return this;
    },

    /**
     * @return {Boolean}
     */
    isAvailable() {
        if (!this.hasOwnProperty('isLoaded')) {
            this.initAvailablity();
        }

        return this.isLoaded;
    },

    /**
     * Get Array from array-like arguments
     * @param  {Object} args [arguments]
     * @return {Array}
     */
    _arrayFromArguments: function (args) {
        'use strict';
        return Array.prototype.slice.call(args);
    },

    /**
     * @return {TrackingAnalytics}
     */
    track() {
        var args = this._arrayFromArguments(arguments);

        if (this.isAvailable()) {
            this._send(args);
        }
        return this;
    },

    /**
     * @param  {Array}   params
     * @param  {Function} callback
     */
    trackWithCallback(params, callback) {
        //Fire the callback, analytics not present or blocked
        if (!this.isAvailable()) {
            return callback();
        }
        this._sendUgaWithCallback(params, callback);

    },

    /**
     * @return {Boolean}
     */
    isAnalyticsAvailable() {

        if (this.type === this.types.google_analytics) {
            return Boolean(window.gtag);
        }

        return false;
    },

    /**
     * @param {Number} index
     * @param {String} variable
     */
    setCustomVariable(index, variable) {
        if (!this.isAvailable()) {
            return;
        }
        this._setCustomVarUGA(index, variable);
    },


    /**
     * @param  {Array}   params
     * @param  {Function} callback
     */
    _sendUgaWithCallback(params, callback) {

        if (callback) {
            params.eventBody.event_callback = callback;
        }

        this._sendUga(params);
    },

    /**
    * Underlying send handler
    */
    _send(args) {
        this._sendUga(args);
    },

    /**
    * Send to Universal Google Analytics
    */
    _sendUga(eventArgs) {

        const { eventName, eventBody } = eventArgs;
        gtag('event', eventName, eventBody);

        return this;
    },


    /**
     * @param {Number} index
     * @param {String} variable
     */
    _setCustomVarUGA(dimension, variable) {
        const dimensionId = `dimension${dimension}`;
        gtag('config', window.GaMeasurementId, {
            [dimensionId]: variable
        });
        return this;
    },

    /**
     * @param {String} actionName
     * @param {Object} data
     */
    setEcommerceAction(actionName, data) {
        if (!this.isAvailable()) {
            return;
        }

        data = data || {};
        // this instance is not used anywhere
        gtag('event', actionName, data);
    },

    /**
     * @param {Object} product
     */
    setEcommerceProduct(product) {
        if (!this.isAvailable()) {
            return;
        }
        gtag('event', 'view_item', {
            items: [product]
        });
    },

    /**
     * @param {Object} product
     */
    setEcommercePromotion(product) {
        if (!this.isAvailable()) {
            return;
        }
        gtag('event', 'view_promotion', {
            promotions: [product]
        });
    }
};

export default TrackingAnalytics;


